export default "__VITE_ASSET__GJqXkrHb__"